import React from "react";

import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import BalPrisonPopulationTrend from "./chart/BalPrisonPopulationTrend";
import BalTotalPrisonerPopulationOfPakistan from "./chart/BalTotalPrisonerPopulationOfPakistan";
import BreakdownOfPrisonersInBal from "./chart/BreakdownOfPrisonersInBal";
import BalBreakdownOfFemalePrisoners from "./chart/BalBreakdownOfFemalePrisoners";
import BalPrisonsBreakdownYear from "./chart/BalPrisonsBreakdownYear";

function BalochistanPrisonStatistics() {
  return (
    <div className="py-5">
      <h2 className="text-h-black">Sindh Prison Statistics</h2>
      <div className="row row-cols-1 row-cols-md-4 py-5">
        <div className="col">
          <p className="punjab-static-h">
            <b>Prison Population Trend</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={2590} redraw={true} separator=",">
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                *
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                *currently, Year 2022
              </p>
            </div>
          </div>
          <BalPrisonPopulationTrend />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Breakdown</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={58} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                remain under-trial
              </p>
            </div>
          </div>
          <BreakdownOfPrisonersInBal />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Balochistan's Share </b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={2.8} redraw={true} decimals={1}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                of the total prison population in Pakistan
              </p>
            </div>
          </div>
          <BalTotalPrisonerPopulationOfPakistan />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Female Prisoners</b>
          </p>
          <div className="d-flex align-items-end">
            <div className="col">
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={35} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                as per Aug, 2022 data
              </p>
            </div>
          </div>
          <BalBreakdownOfFemalePrisoners />
        </div>
      </div>

      <div className="row row-cols-1 row-cols-md-3">
        <div className="col">
          <p className="punjab-static-h">
            <b>Year 2022 Prisons Breakdown</b>
          </p>

          <BalPrisonsBreakdownYear />
        </div>
        <div className="col">
          <div>
            <p className="m-0 punjab-static-h">
              <b>TOTAL JAILS</b>
            </p>
            <div className="d-flex align-items-end">
              <div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "38px",
                    color: "#000",
                    fontFamily: "Abril Fatface",
                  }}
                >
                  <CountUp end={11} redraw={true} separator=",">
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </p>
              </div>
            </div>
            <p className="m-0 punjab-static-h">
              <b>CAPACITY</b>
            </p>
            <div className="d-flex align-items-end">
              <div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "38px",
                    color: "#000",
                    fontFamily: "Abril Fatface",
                  }}
                >
                  <CountUp end={2664} redraw={true} separator=",">
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </p>
              </div>

              <div className="ms-2">
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "10px",
                  }}
                >
                  by end of Year 2021
                </p>
              </div>
            </div>

            <p className="m-0 punjab-static-h ">
              <b>PRISONERS</b>
            </p>
            <div className="d-flex align-items-end">
              <div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "38px",
                    color: "#000",
                    fontFamily: "Abril Fatface",
                  }}
                >
                  <CountUp end={2590} redraw={true} separator=",">
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </p>
              </div>

              <div className="ms-2">
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "10px",
                  }}
                >
                  by end of Aug, 2022
                </p>
              </div>
            </div>

            <p className="m-0 punjab-static-h ">
              <b>WOMEN JAILS</b>
            </p>
            <div className="d-flex align-items-end">
              <div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "38px",
                    color: "#000",
                    fontFamily: "Abril Fatface",
                  }}
                >
                  <CountUp end={0} redraw={true} separator=",">
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </p>
              </div>

              <div className="ms-2">
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "10px",
                  }}
                >
                  only two jails have separate barracks for women
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Facilities Breakdown</b>
          </p>
          <div className="d-flex">
            <div
              style={{
                display: "flex",
                alignItems: "end",
                marginBottom: "10px",
              }}
            >
              <p
                className="m-0"
                style={{
                  fontSize: "18px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                Number of Prison Vans =
              </p>
            </div>
            <div>
              <p
                className="m-0 ms-2"
                style={{
                  fontSize: "18px",
                  color: "red",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={0} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </p>
            </div>
          </div>
          <div className="d-flex">
            <div
              style={{
                display: "flex",
                alignItems: "end",
                marginBottom: "10px",
              }}
            >
              <p
                className="m-0"
                style={{
                  fontSize: "18px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                Number of PCOs =
              </p>
            </div>
            <div>
              <p
                className="m-0 ms-2"
                style={{
                  fontSize: "18px",
                  color: "red",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={0} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </p>
            </div>
          </div>
          <div className="d-flex">
            <div
              style={{
                display: "flex",
                alignItems: "end",
                marginBottom: "10px",
              }}
            >
              <p
                className="m-0"
                style={{
                  fontSize: "18px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                Separate Jails for Women =
              </p>
            </div>
            <div>
              <p
                className="m-0 ms-2"
                style={{
                  fontSize: "18px",
                  color: "red",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={0} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </p>
            </div>
          </div>
          <div className="d-flex">
            <div
              style={{
                display: "flex",
                alignItems: "end",
                marginBottom: "10px",
              }}
            >
              <p
                className="m-0"
                style={{
                  fontSize: "18px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                Juvenile Reformatory Centers =
              </p>
            </div>
            <div>
              <p
                className="m-0 ms-2"
                style={{
                  fontSize: "18px",
                  color: "red",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={0} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </p>
            </div>
          </div>
          <div className="d-flex">
            <div
              style={{
                display: "flex",
                alignItems: "end",
                marginBottom: "10px",
              }}
            >
              <p
                className="m-0"
                style={{
                  fontSize: "18px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                Number of Psychologists/ Psychiatrists =
              </p>
            </div>
            <div>
              <p
                className="m-0 ms-2"
                style={{
                  fontSize: "18px",
                  color: "red",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={0} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BalochistanPrisonStatistics;
